import ChatAvatar from "./chat-avatar";

export default ChatAvatar